import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const censys = defineConnector({
  identifier: "censys",
  name: "Censys",
  tagLine: "Internet asset discovery",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://search\\.censys\\.io/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiId,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Censys](https://search.censys.io/) and navigate to **Account > API** to find your API ID and secret.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Censys API ID",
          required: true,
          target: { kind: "configuration", field: "apiId" },
        },
        {
          kind: "input",
          label: "Censys API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://search.censys.io/api/v2/hosts/search",
  },
});
